// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__3FN2V","pulse":"Skeleton_pulse__dU_6r"};